
import { supabase } from "@/integrations/supabase/client";

/**
 * Send a test email using an email template
 */
export async function sendTestEmail(
  templateId: string,
  to: string,
  testData?: Record<string, any>
): Promise<boolean> {
  try {
    console.log(`Sending test email using template ID: ${templateId} to: ${to}`);
    
    // Fetch the template first to get subject
    const { data: template, error: templateError } = await (supabase as any)
      .from('email_templates')
      .select('*')
      .eq('id', templateId)
      .single();

    if (templateError) {
      throw new Error(`Error fetching template: ${templateError.message}`);
    }

    // Call the edge function to send the email
    const { error } = await supabase.functions.invoke('send-user-email', {
      body: {
        to,
        subject: `[TEST] ${template.subject}`,
        templateId: template.template_id,
        templateData: testData || {}
      }
    });

    if (error) {
      throw new Error(`Failed to send test email: ${error.message}`);
    }

    return true;
  } catch (error: any) {
    console.error("Error in sendTestEmail:", error);
    throw new Error(`Failed to send test email: ${error.message}`);
  }
}
